module.exports = __webpack_public_path__ + "img/empty-basket.4dc8de95.png";